import { initStore } from '../../../common';
import { actions } from './actions';

export const partnersReportStore = (): void => {
	const esaProviderId = process.env.REACT_APP_SITE_TITLE?.includes('Italy') ? '2003' : '2000';

	const initialState = {
		slice: 'PARTNERS_REPORT',
		reports: [],
		reportsLoading: false,
		pagesTotal: 1,
		currentPage: 1,
		gamblingReportList: [],
		games: [],
		partners: [],
		providers: [],
		gameCategories: [],
		devices: [],
		affiliate: [],
		countries: [],
		player_levels: [],
		currencies: [],
		activePartners: [],
		money_type: [
			{ value: '0', label: 'Real Money', isChecked: false },
			{ value: '1', label: 'Fun bonus', isChecked: false },
		],
		rows: [],
		columns: [],
		initialColumns: [],
		filtering: false,
		filters: [
			{ name: 'money_type', value: '0' },
			{ name: 'game_provider_ids', value: esaProviderId },
		],
		globalErrors: [],
		templates: [],
		selectedTotal: { value: 'grand_total', label: 'Grand Total' },
		averageRates: [],
		savingData: false,
		selectedTemplate: undefined,
		globalSuccess: '',
	};

	initStore(actions, initialState);
};
